import styled from "styled-components"

export const CellPhoneField = styled.div `

  width: 250px;
  display: grid;
  grid-template-columns: 35% 55%;
  column-gap: 10%;

`